import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { LoadingStatus } from '@mp/shared/domain';

import { HitList } from '../models';

import { HitListsActions } from './hitlists.actions';

export const hitListsFeatureKey = 'mpms-core-hitlists';

type HitListsEntityState = EntityState<HitList>;

export interface HitListsState {
  hitLists: HitListsEntityState;
  hitListsStatus: LoadingStatus;
}

export const hitListEntityAdapter = createEntityAdapter<HitList>({
  selectId: (hitList: HitList) => hitList.costCenter.costCenterId,
});

export const initialState: HitListsState = {
  hitLists: hitListEntityAdapter.getInitialState(),
  hitListsStatus: LoadingStatus.Loaded,
};

export const hitListsReducer = createReducer(
  initialState,
  on(
    HitListsActions.fetchHitLists,
    (state): HitListsState => ({
      ...state,
      hitListsStatus: LoadingStatus.Loading,
      hitLists: hitListEntityAdapter.getInitialState(),
    }),
  ),
  on(
    HitListsActions.fetchHitListsSuccess,
    (state, { hitLists }): HitListsState => ({
      ...state,
      hitListsStatus: LoadingStatus.Loaded,
      hitLists: hitListEntityAdapter.setAll(hitLists.data, state.hitLists),
    }),
  ),
  on(
    HitListsActions.fetchHitListsError,
    (state): HitListsState => ({
      ...state,
      hitListsStatus: LoadingStatus.Error,
      hitLists: hitListEntityAdapter.getInitialState(),
    }),
  ),
);

export const { selectAll: selectAllHitList } = hitListEntityAdapter.getSelectors();
